<template>
  <div class="wrapper">
    <div class="entry-support__head" @click="$router.push('/')">
            <div class="entry-support__lang"></div>
            <div class="entry-support__logo">
              <img
                :src="require('@/assets/images/svg/logo-white.svg')"
                alt="logo"
                height="64"
                width="185"
              />
            </div>
          </div>
    <div class="entry">
      <div class="entry__body">
        <div class="entry-form">
          <div v-if="title" class="entry-form__title">{{ title }}</div>
          <slot />
        </div>
      </div>
      <div class="entry__support">
        <div class="entry-support">
          <div class="entry-support__head">
            <div class="entry-support__lang"></div>
            <div class="entry-support__logo">
              <img
                :src="require('@/assets/images/svg/logo-white.svg')"
                alt="logo"
                height="64"
                width="185"
              />
            </div>
          </div>
          <div class="entry-support__title">{{ $t("auth.need_help") }}</div>
          <div
            class="entry-support__desc"
            v-html="$t('auth.send_message')"
          ></div>
          <div class="entry-support__links">
            <a class="btn" href="https://t.me/Leo31PH" target="_blank">
              <svg
                v-svg
                role="presentation"
                size="0 0 20 18"
                symbol="telegram2"
              ></svg>
              Leo31PH
            </a>
            <a class="btn" href="https://t.me/Robert_ph" target="_blank">
              <svg
                v-svg
                role="presentation"
                size="0 0 20 18"
                symbol="telegram2"
              ></svg>
              Robert_ph
            </a>
            <a
              class="btn"
              href="skype:push.house.partner17:11?chat"
              target="_blank"
            >
              <svg
                v-svg
                role="presentation"
                size="0 0 20 20"
                symbol="skype"
              ></svg>
              Pushhouse
            </a>
          </div>
        </div>
        <span class="publisher">
          <svg
            width="135"
            height="970"
            viewBox="0 0 135 970"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.02"
              d="M-23.2067 985.388L-23.2067 936.346C-23.2067 925.6 -21.1633 917.502 -17.0765 912.053C-13.141 906.452 -7.54061 902.744 -0.275179 900.928C6.99024 898.96 16.6018 897.976 28.5595 897.976C40.0631 897.976 49.5233 898.884 56.9401 900.7C64.2055 902.517 69.9573 906.301 74.1954 912.053C78.4336 917.653 80.5527 925.902 80.5527 936.801L80.5527 959.505L133 959.505L133 985.388L-23.2067 985.388ZM57.1671 942.931C57.1671 937.028 56.4103 932.789 54.8967 930.216C53.383 927.643 50.7342 925.978 46.9501 925.221C43.166 924.464 37.0358 924.086 28.5595 924.086C20.2345 924.086 14.18 924.464 10.3959 925.221C6.61184 925.978 3.96299 927.643 2.44935 930.216C0.93572 932.789 0.178906 936.952 0.178906 942.704L0.178907 959.505L57.1671 959.505L57.1671 942.931ZM-23.2067 773.164L64.2055 773.164C84.6395 773.164 99.5488 774.072 108.933 775.888C118.166 777.704 124.826 781.716 128.913 787.921C132.849 794.127 134.816 804.344 134.816 818.572C134.816 832.801 132.849 843.018 128.913 849.223C124.826 855.429 118.166 859.44 108.933 861.257C99.5488 862.922 84.6395 863.754 64.2055 863.754L-23.2067 863.754L-23.2067 837.871L73.9684 837.871C86.0774 837.871 94.5538 837.568 99.3974 836.963C104.09 836.206 107.268 834.541 108.933 831.968C110.598 829.395 111.431 824.93 111.431 818.572C111.431 812.064 110.598 807.523 108.933 804.95C107.268 802.377 104.09 800.787 99.3974 800.182C94.5538 799.425 86.0774 799.047 73.9684 799.047L-23.2067 799.047L-23.2067 773.164ZM-23.2067 731.435L-23.2067 680.35C-23.2067 667.938 -19.9524 658.781 -13.4438 652.878C-6.93517 646.823 2.90342 643.796 16.072 643.796C26.9702 643.796 35.3708 645.537 41.274 649.018C47.1771 652.499 51.0369 657.948 52.8532 665.365L53.7614 665.365C55.7291 657.04 59.6646 651.137 65.5677 647.656C71.3195 644.174 79.9472 642.434 91.4508 642.434C104.922 642.434 115.215 645.31 122.329 651.061C129.443 656.813 133 666.652 133 680.577L133 731.435L-23.2067 731.435ZM42.1822 687.389C42.1822 680.88 40.7442 676.339 37.8683 673.766C34.841 671.193 29.3163 669.906 21.294 669.906C15.3909 669.906 11.0014 670.36 8.12546 671.268C5.09819 672.177 3.05479 673.842 1.99525 676.263C0.784348 678.685 0.178895 682.394 0.178895 687.389L0.178896 705.552L42.1822 705.552L42.1822 687.389ZM109.841 686.48C109.841 681.485 109.236 677.777 108.025 675.355C106.814 672.782 104.695 671.041 101.668 670.133C98.6406 669.225 94.0997 668.771 88.0452 668.771C81.9906 668.771 77.3741 669.301 74.1954 670.36C71.0168 671.42 68.822 673.16 67.6111 675.582C66.4002 678.004 65.7948 681.637 65.7948 686.48L65.7948 705.552L109.841 705.552L109.841 686.48ZM133 604.68L-23.2067 604.68L-23.2067 578.797L108.933 578.797L108.933 535.659L133 535.659L133 604.68ZM133 502.753L-23.2067 502.753L-23.2067 476.643L133 476.643L133 502.753ZM134.816 396.871C134.816 403.077 134.514 409.888 133.908 417.305C133.303 424.722 132.47 431.155 131.411 436.604L109.387 436.604C110.75 423.738 111.431 412.915 111.431 404.136C111.431 393.541 109.766 386.805 106.436 383.929C104.922 382.416 102.879 381.432 100.306 380.978C97.581 380.524 93.9483 380.297 89.4074 380.297C83.0502 380.297 78.5093 380.675 75.7847 381.432C73.0602 382.189 71.0925 383.702 69.8816 385.973C68.5193 388.092 67.3841 391.876 66.4759 397.325L62.6162 419.802C61.4052 427.37 57.3941 432.592 50.5828 435.468C43.7714 438.193 33.9328 439.555 21.067 439.555C8.95795 439.555 -0.426565 437.815 -7.08654 434.333C-13.8979 430.852 -18.5901 425.933 -21.1633 419.575C-23.7365 413.218 -25.0231 405.12 -25.0231 395.281C-25.0231 388.924 -24.569 382.491 -23.6608 375.983C-22.904 369.323 -21.9958 364.025 -20.9363 360.09L0.632977 360.09C-0.88066 367.96 -1.63748 377.194 -1.63748 387.789C-1.63748 393.844 -1.33475 398.536 -0.729298 401.866C-0.123844 405.196 0.935697 407.693 2.44933 409.358C3.96296 411.175 6.00637 412.386 8.57953 412.991C11.1527 413.445 15.0125 413.672 20.1588 413.672C25.6079 413.672 29.5433 413.369 31.9651 412.764C34.2356 412.158 35.9006 411.099 36.9601 409.585C38.0197 407.92 38.8521 405.196 39.4576 401.412L43.0903 380.297C43.9985 374.393 45.7392 369.625 48.3123 365.993C50.8855 362.209 55.1994 359.333 61.2539 357.365C67.4598 355.397 75.7091 354.413 86.0017 354.413C99.4731 354.413 109.766 356.003 116.88 359.181C123.843 362.36 128.61 366.977 131.184 373.031C133.605 378.934 134.816 386.881 134.816 396.871ZM133 251.475L66.4759 251.475L66.4759 291.435L133 291.435L133 317.318L-23.2067 317.318L-23.2067 291.435L42.1821 291.435L42.1821 251.475L-23.2067 251.475L-23.2067 225.592L133 225.592L133 251.475ZM133 183.025L-23.2067 183.025L-23.2067 108.554L0.17887 108.554L0.178872 157.142L42.4092 157.142L42.4092 115.139L65.7948 115.139L65.7948 157.142L109.614 157.142L109.614 108.554L133 108.554L133 183.025ZM133 6.1909L76.0118 22.9922L76.0118 45.2426L133 45.2426L133 71.1257L-23.2067 71.1257L-23.2067 20.7218C-23.2067 9.82363 -21.3147 1.65002 -17.5306 -3.79905C-13.7465 -9.39948 -8.37314 -13.1079 -1.41044 -14.9242C5.55226 -16.892 14.7854 -17.8758 26.289 -17.8758C37.4899 -17.8758 46.7987 -16.7406 54.2155 -14.4701C61.6323 -12.3511 67.0813 -7.96154 70.5627 -1.30156L133 -21.0544L133 6.1909ZM52.6262 26.852C52.6262 21.1002 51.945 16.9377 50.5828 14.3645C49.0691 11.7913 46.5716 10.1264 43.0903 9.36953C39.4576 8.46136 33.8571 8.00727 26.289 8.00727C18.7208 8.00727 13.1961 8.46136 9.71474 9.36953C6.23339 10.1264 3.81158 11.7913 2.44931 14.3645C0.93568 16.9377 0.178866 21.1002 0.178866 26.852L0.178867 45.2426L52.6262 45.2426L52.6262 26.852Z"
              fill="white"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { setLangHeader } from "@/services/AxiosService";
import "@/assets/css/vendor/bootstrap.min.css";
import "@/assets/css/main.scss";
import "@/assets/css/page-entry.scss";

export default {
  name: "AuthLayout",
  computed: {
    title() {
      return this.$route.meta.pageTitle
        ? this.$t(`auth.${this.$route.meta.pageTitle}`)
        : "";
    },
    linkTo() {
      return this.$route.name === "Login" ? "/registration" : "/login";
    },
    tileTo() {
      return this.$route.name === "Login"
        ? this.$t(`auth.sign_up`)
        : this.$t(`auth.sign_in`);
    },
    subtitle() {
      return this.$route.name === "Registration"
        ? this.$t(`auth.have_account`)
        : this.$route.name === "Login"
        ? this.$t(`auth.have_not_account`)
        : "";
    },
  },
  watch: {
    "$i18n.locale": function () {
      setLangHeader(localStorage.getItem("lang"));
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .entry-support__head {
    @media (min-width: 768px) {
      display: none;
    }
  }
}
.entry__support {
  position: relative;
  .entry-support__head {
    @media (max-width: 768px) {
    display: none;
    }
  }
  .publisher {
    position: absolute;

    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>